export const selectStyles = {
  control: (baseStyles, state) => ({
    ...baseStyles,
    border: "1px solid #BC865399",
    borderRadius: "6px",
    boxShadow: state.isFocused ? "0 0 0 .25rem #BC865380" : "",
    fontFamily: "RobotoRegular",
    fontSize: "16px",
    lineHeight: "21px",
    letterSpacing: "0px",
    textAlign: "left",
    color: "#233E5A",
    padding: "4px 0",
    marginTop: "6px",
    "&:hover": {
      border: "1px solid #BC865399",
    },
  }),
  input: (baseStyles) => ({
    ...baseStyles,
    fontFamily: "RobotoRegular",
    fontSize: "16px",
    lineHeight: "21px",
    letterSpacing: "0px",
    textAlign: "left",
    color: "#233E5A",
  }),
  placeholder: (baseStyles) => ({
    ...baseStyles,
    color: "#BC865380",
  }),
  dropdownIndicator: (baseStyles) => ({
    ...baseStyles,
    color: "#BC865399",
    "&:hover": {
      color: "#BC865399",
      cursor: "pointer",
    },
  }),
  indicatorSeparator: (baseStyles) => ({
    ...baseStyles,
    backgroundColor: "#BC865399",
  }),
  noOptionsMessage: (baseStyles) => ({
    ...baseStyles,
    color: "#BC865380",
  }),
  option: (baseStyles, state) => ({
    ...baseStyles,
    fontFamily: "RobotoRegular",
    fontSize: "16px",
    lineHeight: "21px",
    letterSpacing: "0px",
    textAlign: "left",
    backgroundColor: state.isSelected ? "#BC8653" : "",
    color: state.isSelected ? "#F4F7FA" : "#233E5A",
    "&:hover": {
      color: "#F4F7FA",
      backgroundColor: "#BC865380",
      cursor: "pointer",
    },
  }),
};
